import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthService} from '../services/auth.service';
import {AuthUsersGuard} from './authUsers.guard';
import {NonAuthUsersGuard} from './nonAuthUsers.guard';
import {AllUsersGuard} from './allUsers.guard';
import {HttpClientModule} from '@angular/common/http';
import {GuardService} from '../services/guard.service';
import {ResponseService} from '../services/response.service';
import {UrlService} from '../services/url.service';
import {FormChangesGuard} from "./formChanges.guard";



@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    CommonModule
  ],
  providers: [
    AuthService,
    GuardService,
    AllUsersGuard,
    AuthUsersGuard,
    NonAuthUsersGuard,
    FormChangesGuard,
    ResponseService,
    UrlService
  ]
})
export class GuardsModule { }
